import * as React from 'react'
import styled from 'styled-components'
import { NewsCardItem_NewsItemFragment } from 'generated/graphql'
import Pagination from '@app.components/Pagination/Pagination'
import NewsCardItem from '../screen/menus/News/NewsCardList/NewsCardItem'
import NewsCardListEmpty from './NewsCardList.empty'
import NewsCardListLoading from './NewsCardList.loading'

type TProps = {
  data?: NewsCardItem_NewsItemFragment[]
  totalCount: number
}

const NewsCardList: React.FC<TProps> = ({ data, totalCount }) => {
  if (!data) return <NewsCardListLoading />
  if (data.length === 0) return <NewsCardListEmpty />
  return (
    <StyledWrapper>
      <div className="hr" />
      {data.map((node, idx) => (
        <NewsCardItem data={node} key={idx} />
      ))}
      <Pagination
        className="pg"
        pageSize={10}
        stepSize={10}
        totalCount={totalCount}
      />
    </StyledWrapper>
  )
}

export default NewsCardList

const StyledWrapper = styled.div`
  margin-bottom: 40px;
  .hr {
    height: 1px;
    background-color: #eeeeee;
  }
  .pg {
    margin-top: 40px;
  }
`
